import { defineComponent as _defineComponent } from 'vue'
import router from '@/router';
import { store } from '@/store/index';
import { dispatchResetPassword } from '@/store/main/actionsMain';
import { commitAddNotification } from '@/store/main/mutations';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import ResetPasswordForm from '@/views/pages/resetPassword/ResetPasswordForm.vue';
import { onMounted, ref } from 'vue';
import { checkToken } from '@/plugins/jwt-decode';
import { defineMessages } from '@/lib/i18n';
import { generalApi } from '@/lib/api/general';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordPage',
  setup(__props) {

const m = defineMessages({
  changePassword: 'パスワードを変更',
  invalidToken:
    'パスワードリセットリンクが無効または期限切れです。再度パスワード再発行の手続きを行ってください。',
  passwordResetFailed:
    'パスワードのリセットに失敗しました。もう一度お試しいただくか、サポートにお問い合わせください。',
});

const isValidForm = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const isReady = ref<boolean>(false);
const password = ref<string>('');
const passwordConfirmation = ref<string>('');
const passwordMinLength = ref<number>(8);

const validateToken = async (): Promise<string | null> => {
  const token = router.currentRoute.query.token as string;
  const result = await checkToken(token, store);
  if (!result.isValid) {
    commitAddNotification(store, {
      messageKey: m.invalidToken,
      color: 'error',
    });
    router.replace({ name: 'passwordRecovery' });
    return null;
  }
  return result.token;
};

const submit = async (): Promise<void> => {
  if (!isValidForm.value) {
    return;
  }

  isLoading.value = true;
  try {
    const passwordResetToken = await validateToken();
    if (!passwordResetToken) {
      return;
    }

    await dispatchResetPassword(store, {
      passwordResetToken,
      password: password.value,
    });
  } catch (e) {
    console.error(e);
    commitAddNotification(store, {
      messageKey: m.passwordResetFailed,
      color: 'error',
    });
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  isReady.value = false;
  await validateToken();
  const token = router.currentRoute.query.token as string;
  try {
    const { data } = await generalApi.getCompanyPasswordLength({
      token: token,
    });
    passwordMinLength.value = data.password_length;
  } catch (e) {
    // We do not disturb resetting password even if request is failed
  } finally {
    isReady.value = true;
  }
});

return { __sfc: true,m, isValidForm, isLoading, isReady, password, passwordConfirmation, passwordMinLength, validateToken, submit, BaseButtonSubmit, BaseFormCard, ResetPasswordForm }
}

})